(function (angular) {
    "use strict";

    angular.module('mobilezuz').directive('spRadioOptions', ['$timeout',
        function () {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    options: '=',
                    spModel: '=?',
                    label: '@',
                    spChange: '&?'
                },
                template: '' +
                '<div class="sp-radio-options">' +
                '   <span id="{{option.id}}" class="sp-radio-option" ng-repeat="option in options" ng-click="setModel(option)" ng-class="{active: spModel == option}">' +
                '       <span class="for-vertical-align"></span><!--' +
                '       --><span>{{$eval(label, {option: option})}}</span>' +
                '   </span>' +
                '</div>',
                controller: ['$scope', function($scope) {
                    $scope.setModel = setModel;

                    function setModel(option) {
                        $scope.spModel = option;
                    }

                    if ($scope.spChange) {
                        $scope.$watch('spModel', function() {
                            $scope.spChange();
                        });
                    }
                }]
            };
        }]);
})(angular);